export default "__VITE_ASSET__u9GwM_8i__"